module.exports = {"id":"228908","name":"Jason Berthomier","rating":"72","photo":"./data/images/photos/3/228908.png","club":{"name":"Stade Brestois","logo":"./data/images/clubs/StadeBrestois.png"},"positions":["MG","MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JasonBerthomier0.json
// module id = 1926
// module chunks = 0